module.exports = __webpack_public_path__ + "media/favicon/mstile-310x310-93bcb558.png";